import React from 'react';
import { HUB_SRC } from '../data/assets';

/**
 * The instruction pipeline: standing signals compose into one governed
 * instruction that is seated before the model, then receipted.
 */
export function PipelineDiagram() {
  return <svg viewBox="40 22 380 438" width="90%" style={{
    margin: '0 auto'
  }} fill="none" xmlns="http://www.w3.org/2000/svg" fontFamily="JetBrains Mono, monospace" role="img" aria-label="Prompt plus standing signals — policy, brand, role and industry — compose into one governed instruction seated before the model, then signed and retained." data-id="element-240" data-mp="2i25nfi5k6ucv">
      {/* connectors */}
      <g stroke="#9AA2AC" strokeWidth="1.4" strokeDasharray="2 5" data-id="element-241" data-mp="1za341z1j8zyx">
        <path d="M230 60 L230 122" data-id="element-242" data-mp="24c2717td1uvc" />
        <path d="M152 118 L204 146" data-id="element-243" data-mp="248xvtqhh9yv6" />
        <path d="M152 182 L204 154" data-id="element-244" data-mp="1qazmizi0ksmj" />
        <path d="M308 118 L256 146" data-id="element-245" data-mp="1qc147mtjcdd8" />
        <path d="M308 182 L256 154" data-id="element-246" data-mp="1ud366beu73iw" />
        <path d="M230 176 L230 250" data-id="element-247" data-mp="1uc1ldf80r2nz" />
        <path d="M230 314 L230 350" data-id="element-248" data-mp="1uf78iox37uh2" />
        <path d="M230 382 L230 420" data-id="element-249" data-mp="1i7vecnowkan5" />
      </g>
      {/* direction chevrons */}
      <g stroke="#0E6FA3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-250" data-mp="1d9br8jykost7">
        <path d="M226 88 L230 93 L234 88" data-id="element-251" data-mp="1dbo4wkxash0g" />
        <path d="M226 210 L230 215 L234 210" data-id="element-252" data-mp="1s5jani25pq7f" />
        <path d="M226 328 L230 333 L234 328" data-id="element-253" data-mp="1s4881lkg6ohw" />
        <path d="M226 397 L230 402 L234 397" data-id="element-254" data-mp="1n77yh0oe33m1" />
      </g>
      {/* PROMPT */}
      <rect x="170" y="30" width="120" height="30" rx="15" fill="#fff" stroke="#0E6FA3" data-id="element-255" data-mp="zhnf4gobq4c8" />
      <text x="230" y="49" textAnchor="middle" fill="#0F5480" fontSize="11" letterSpacing="1" data-id="element-256" data-mp="uiu54y88wvgt">
        PROMPT
      </text>
      {/* standing signals */}
      <g stroke="#9AA2AC" data-id="element-257" data-mp="1999pkasu7zdx">
        <rect x="48" y="103" width="104" height="30" rx="15" fill="#fff" data-id="element-258" data-mp="199jgq1pmccl7" />
        <rect x="48" y="167" width="104" height="30" rx="15" fill="#fff" data-id="element-259" data-mp="14ffaxls3aalp" />
        <rect x="308" y="103" width="104" height="30" rx="15" fill="#fff" data-id="element-260" data-mp="gqdv3dgxfx6e" />
        <rect x="308" y="167" width="104" height="30" rx="15" fill="#fff" data-id="element-261" data-mp="bsuhmfs1zofi" />
      </g>
      <g fill="#5A626C" fontSize="11" letterSpacing="1" textAnchor="middle" data-id="element-262" data-mp="11ggd9r0ze6cm">
        <text x="100" y="122" data-id="element-263" data-mp="11edp7cje2naj">
          POLICY
        </text>
        <text x="100" y="186" data-id="element-264" data-mp="15h0d52cxvo2g">
          BRAND
        </text>
        <text x="360" y="122" data-id="element-265" data-mp="1a91vn60pab0x">
          ROLE
        </text>
        <text x="360" y="186" data-id="element-266" data-mp="1a9jyilhvbnht">
          INDUSTRY
        </text>
      </g>
      {/* Synthia hub */}
      <circle cx="230" cy="150" r="30" fill="#fff" data-id="element-267" data-mp="1f73bzj6qrw8p" />
      <image href={HUB_SRC} x="208" y="131" width="44" height="37" preserveAspectRatio="xMidYMid meet" data-id="element-268" data-mp="ii478e5d9cl9" />
      {/* governed instruction */}
      <rect x="150" y="250" width="160" height="64" rx="3" fill="#fff" stroke="#0E6FA3" strokeWidth="2" data-id="element-269" data-mp="mjhaqhkzl3p0" />
      <text x="230" y="278" textAnchor="middle" fill="#0F5480" fontSize="12" letterSpacing="1" data-id="element-270" data-mp="rgzabhd466kc">
        GOVERNED
      </text>
      <text x="230" y="296" textAnchor="middle" fill="#0F5480" fontSize="12" letterSpacing="1" data-id="element-271" data-mp="22xfshig1z1aw">
        INSTRUCTION
      </text>
      <g stroke="#151A21" strokeWidth="2" data-id="element-272" data-mp="27vr2bt6clbt4">
        <path d="M140 240 h10 M140 240 v10" data-id="element-273" data-mp="27upj31f6hj0b" />
        <path d="M320 240 h-10 M320 240 v10" data-id="element-274" data-mp="3sf4b7qdfiy95" />
        <path d="M140 324 h10 M140 324 v-10" data-id="element-275" data-mp="3sdt71pg2nohi" />
        <path d="M320 324 h-10 M320 324 v-10" data-id="element-276" data-mp="3neygg1bv4vmu" />
      </g>
      {/* the model */}
      <rect x="158" y="350" width="144" height="32" rx="16" fill="#fff" stroke="#0E6FA3" strokeDasharray="5 3" data-id="element-277" data-mp="3iorsm3p6df5n" />
      <text x="230" y="370" textAnchor="middle" fill="#0F5480" fontSize="11" letterSpacing="1" data-id="element-278" data-mp="3dpyi8k56q49p">
        THE MODEL
      </text>
      {/* signed / retained */}
      <circle cx="230" cy="436" r="16" fill="#E6F0F6" stroke="#0E6FA3" strokeWidth="2" data-id="element-279" data-mp="39pefn11ue8g6" />
      <path d="M223 436 l5 5 l9 -11" stroke="#0E6FA3" strokeWidth="2.2" data-id="element-280" data-mp="34nfgy4h1rzpk" />
      <text x="204" y="441" textAnchor="end" fill="#5A626C" fontSize="10.5" letterSpacing="1.5" data-id="element-281" data-mp="2zqyqv4qafb9u">
        SIGNED
      </text>
      <text x="256" y="441" textAnchor="start" fill="#5A626C" fontSize="10.5" letterSpacing="1.5" data-id="element-282" data-mp="2usdslaulj1o1">
        RETAINED
      </text>
    </svg>;
}